/** Talent search, profile, filters. Catalog labels come from catalogs/*. */
const dictionary = {
  "en": {
    "tags": {
      "employee": "Employee",
      "pendingInvite": "Pending consent",
      "teamInviteSent": "Team invite sent",
      "candidate": "Candidate",
      "pendingConsent": "Pending consent"
    },
    "actions": {
      "hire": "Hire",
      "inviteToPool": "Invite To Pool",
      "removeFromPool": "Remove from pool",
      "moveToAnotherPool": "Move To Another Pool",
      "deleteFromPool": "Delete From Pool",
      "moveToAnotherPoolLabel": "Move to Another Pool",
      "deleteFromThePool": "Delete From the Pool",
      "copyAllEmail": "Copy all email",
      "deleteFromPoolMenu": "Delete from pool",
      "moveToAnotherPoolMenu": "Move to another pool"
    },
    "sections": {
      "motivations": "Motivational factors",
      "workStyles": "Work style preferences",
      "reasoningAndSkills": "Reasoning and Skills",
      "assessmentReports": "Assessment Reports",
      "targetPositionCompetencies": "Target Position Competencies",
      "highestCompatibility": "Highest compatibility"
    },
    "scale": {
      "ifAboveAverage": "If above Average",
      "ifBelowAverage": "If below Average"
    },
    "help": {
      "workStyles": "The higher the score on the competence, the more a person likes and has potential to do the activity compared to other activities. The lower the score on the competence, the less a person likes to do the activity compared to other activities.",
      "motivations": "The higher the result in the area, the more important the Value & Motivation factor is to the person in relation to other factors. Top of the list motivates the person a lot. Low score does not necessarily mean that the factor does not matter at all",
      "reasoningAndSkills": "The higher the score on the skill, the more a person likes and has potential to do it compared to other skills. The lower the score on the skill, the less a person likes to do it compared to other skills."
    },
    "waitingInvite": "Waiting for candidate to accept invite",
    "deleteCandidate": "Delete Candidate",
    "deleteCandidateBody": "This action canot be undone. Please go to the specific pool page and remove the candidate from there",
    "goToPool": "Go to Pool",
    "goToPoolNamed": "Go to {title}",
    "moveSelected": "Move Selected Candidates to Another Pool",
    "moveNamedPrefix": "Move",
    "moveNamedSuffix": "to Another Pool",
    "removeFromOrigin": "Remove from Origin Pool",
    "actionsForTalent": "Actions For Talent",
    "pools": "Pools:",
    "teams": "Teams:",
    "addCandidateToTeam": "Add candidate to the team",
    "selectTeam": "Select team",
    "inviteCandidateForPosition": "Invite candidate for position",
    "jobPositions": "Job Positions",
    "selectJobPosition": "Select job position",
    "matchPercent": "{percentage}% match",
    "percentMatch": "{percentage}% Match",
    "downloadableReportAlt": "Downloadable Report",
    "sendReminder": "Send assessments reminder",
    "status": "Status",
    "filters": {
      "addFilter": "Add Filter",
      "apply": "Apply",
      "valueBetween": "Value between {min}-{max}",
      "savedFilters": "Saved Filters",
      "saveFilter": "Save Filter",
      "saveFilterPrompt": "Please enter name of this filter",
      "filterName": "Filter name",
      "filterNameExample": "e.g. Company shared values",
      "type": "Type",
      "selectType": "Select Type",
      "selectTeamsList": "Select Teams List",
      "selectJobPositionList": "Select Job Position List",
      "search": "Search",
      "teamsAssignedNone": "no team assigned",
      "teamsAssignedOne": "{count} team assigned",
      "teamsAssignedMany": "{count} teams assigned",
      "poolsAssignedNone": "no pool assigned",
      "poolsAssignedOne": "{count} pool assigned",
      "poolsAssignedMany": "{count} pools assigned"
    },
    "perfectMatches": "{matches} perfect matches out of {total} candidates",
    "grid": {
      "sortAsc": "Sort by ASC",
      "sortDesc": "Sort by DESC",
      "filter": "Filter",
      "hideColumn": "Hide column",
      "manageColumns": "Manage columns",
      "prev": "Prev",
      "next": "Next"
    },
    "toasts": {
      "moveFailed": "Failed to move candidate to team {name}. Please try again.",
      "reminderSent": "Reminder email sent",
      "reminderError": "Unable to reminder email",
      "generatingReport": "Generating report...",
      "reportGenerated": "Report generated successfully",
      "reportFailedRetry": "Failed to generate report. Please try again. Or contact our support team.",
      "reportFailed": "Failed to generate report"
    }
  },
  "de": {
    "tags": {
      "employee": "Mitarbeitender",
      "pendingInvite": "Einwilligung ausstehend",
      "teamInviteSent": "Teameinladung gesendet",
      "candidate": "Kandidat:in",
      "pendingConsent": "Einwilligung ausstehend"
    },
    "actions": {
      "hire": "Einstellen",
      "inviteToPool": "In Pool einladen",
      "removeFromPool": "Aus Pool entfernen",
      "moveToAnotherPool": "In anderen Pool verschieben",
      "deleteFromPool": "Aus Pool löschen",
      "moveToAnotherPoolLabel": "In anderen Pool verschieben",
      "deleteFromThePool": "Aus dem Pool löschen",
      "copyAllEmail": "Alle E-Mails kopieren",
      "deleteFromPoolMenu": "Aus Pool löschen",
      "moveToAnotherPoolMenu": "In anderen Pool verschieben"
    },
    "sections": {
      "motivations": "Werte & Motivation",
      "workStyles": "Arbeitsstile",
      "reasoningAndSkills": "Kognitive Fähigkeiten",
      "assessmentReports": "Assessment-Berichte",
      "targetPositionCompetencies": "Kompetenzen der Zielposition",
      "highestCompatibility": "Höchste Passung"
    },
    "scale": {
      "ifAboveAverage": "Wenn überdurchschnittlich",
      "ifBelowAverage": "Wenn unterdurchschnittlich"
    },
    "help": {
      "workStyles": "Je höher der Wert, desto mehr mag und kann die Person diese Tätigkeit im Vergleich zu anderen Tätigkeiten. Je niedriger der Wert, desto weniger mag die Person diese Tätigkeit im Vergleich zu anderen.",
      "motivations": "Je höher das Ergebnis im Bereich, desto wichtiger ist der Werte- und Motivationsfaktor für die Person im Verhältnis zu anderen Faktoren. Die Punkte oben auf der Liste motivieren stark. Ein niedriger Wert bedeutet nicht unbedingt, dass der Faktor gar keine Rolle spielt",
      "reasoningAndSkills": "Je höher der Wert bei der Fähigkeit, desto mehr liegt der Person diese im Vergleich zu anderen Fähigkeiten. Je niedriger der Wert, desto weniger liegt der Person diese im Vergleich zu anderen Fähigkeiten."
    },
    "waitingInvite": "Warten auf Annahme der Einladung",
    "deleteCandidate": "Kandidat:in löschen",
    "deleteCandidateBody": "Diese Aktion kann nicht rückgängig gemacht werden. Bitte gehen Sie zur jeweiligen Pool-Seite und entfernen Sie die Person dort",
    "goToPool": "Zum Pool",
    "goToPoolNamed": "Zu {title}",
    "moveSelected": "Ausgewählte Kandidat:innen in einen anderen Pool verschieben",
    "moveNamedPrefix": "Verschieben",
    "moveNamedSuffix": "in einen anderen Pool",
    "removeFromOrigin": "Aus dem Ursprungspool entfernen",
    "actionsForTalent": "Aktionen für Talent",
    "pools": "Pools:",
    "teams": "Teams:",
    "addCandidateToTeam": "Kandidat:in zum Team hinzufügen",
    "selectTeam": "Team auswählen",
    "inviteCandidateForPosition": "Kandidat:in für Position einladen",
    "jobPositions": "Stellen",
    "selectJobPosition": "Stelle auswählen",
    "matchPercent": "{percentage}% Passung",
    "percentMatch": "{percentage}% Passung",
    "downloadableReportAlt": "Herunterladbarer Bericht",
    "sendReminder": "Erinnerung zu Assessments senden",
    "status": "Status",
    "filters": {
      "addFilter": "Filter hinzufügen",
      "apply": "Anwenden",
      "valueBetween": "Wert zwischen {min}-{max}",
      "savedFilters": "Gespeicherte Filter",
      "saveFilter": "Filter speichern",
      "saveFilterPrompt": "Bitte geben Sie den Namen dieses Filters ein",
      "filterName": "Filtername",
      "filterNameExample": "z. B. Gemeinsame Unternehmenswerte",
      "type": "Typ",
      "selectType": "Typ auswählen",
      "selectTeamsList": "Teamliste auswählen",
      "selectJobPositionList": "Positionsliste auswählen",
      "search": "Suche",
      "teamsAssignedNone": "kein team zugewiesen",
      "teamsAssignedOne": "{count} team zugewiesen",
      "teamsAssignedMany": "{count} teams zugewiesen",
      "poolsAssignedNone": "keinen pool zugewiesen",
      "poolsAssignedOne": "{count} pool zugewiesen",
      "poolsAssignedMany": "{count} pools zugewiesen"
    },
    "perfectMatches": "{matches} von {total} vollständige Matches",
    "grid": {
      "sortAsc": "Aufsteigend sortieren",
      "sortDesc": "Absteigend sortieren",
      "filter": "Filter",
      "hideColumn": "Spalte ausblenden",
      "manageColumns": "Spalten bearbeiten",
      "prev": "zurück",
      "next": "weiter"
    },
    "toasts": {
      "moveFailed": "Kandidat:in konnte nicht ins Team {name} verschoben werden. Bitte versuchen Sie es erneut.",
      "reminderSent": "Erinnerungs-E-Mail gesendet",
      "reminderError": "Erinnerungs-E-Mail konnte nicht gesendet werden",
      "generatingReport": "Bericht wird erstellt...",
      "reportGenerated": "Bericht erfolgreich erstellt",
      "reportFailedRetry": "Bericht konnte nicht erstellt werden. Bitte versuchen Sie es erneut oder kontaktieren Sie unser Support-Team.",
      "reportFailed": "Bericht konnte nicht erstellt werden"
    }
  },
  "fi": {
    "tags": {
      "employee": "Työntekijä",
      "pendingInvite": "Odottaa suostumusta",
      "teamInviteSent": "Tiimikutsu lähetetty",
      "candidate": "Hakija",
      "pendingConsent": "Odottaa suostumusta"
    },
    "actions": {
      "hire": "Palkkaa",
      "inviteToPool": "Kutsu pooliin",
      "removeFromPool": "Poista poolista",
      "moveToAnotherPool": "Siirrä toiseen pooliin",
      "deleteFromPool": "Poista poolista",
      "moveToAnotherPoolLabel": "Siirrä toiseen pooliin",
      "deleteFromThePool": "Poista poolista",
      "copyAllEmail": "Kopioi kaikki sähköpostit",
      "deleteFromPoolMenu": "Poista poolista",
      "moveToAnotherPoolMenu": "Siirrä toiseen pooliin"
    },
    "sections": {
      "motivations": "Motivaatiotekijät",
      "workStyles": "Työskentelytyylit",
      "reasoningAndSkills": "Päättely ja taidot",
      "assessmentReports": "Arviointiraportit",
      "targetPositionCompetencies": "Kohdetehtävän osaamisalueet",
      "highestCompatibility": "Suurin yhteensopivuus"
    },
    "scale": {
      "ifAboveAverage": "Jos keskiarvon yläpuolella",
      "ifBelowAverage": "Jos keskiarvon alapuolella"
    },
    "help": {
      "workStyles": "Mitä korkeampi osaamisalueen pistemäärä, sitä enemmän henkilö pitää kyseisestä toiminnasta ja sitä enemmän hänellä on siihen potentiaalia muihin toimintoihin verrattuna. Mitä matalampi osaamisalueen pistemäärä, sitä vähemmän henkilö pitää kyseisestä toiminnasta muihin toimintoihin verrattuna.",
      "motivations": "Mitä korkeampi tulos alueella, sitä tärkeämpi arvo- tai motivaatiotekijä on henkilölle muihin tekijöihin verrattuna. Listan kärjessä olevat tekijät motivoivat henkilöä paljon. Matala pistemäärä ei välttämättä tarkoita, ettei tekijällä olisi lainkaan merkitystä.",
      "reasoningAndSkills": "Mitä korkeampi taidon pistemäärä, sitä enemmän henkilö pitää sen tekemisestä ja sitä enemmän hänellä on siihen potentiaalia muihin taitoihin verrattuna. Mitä matalampi taidon pistemäärä, sitä vähemmän henkilö pitää sen tekemisestä muihin taitoihin verrattuna."
    },
    "waitingInvite": "Odotetaan, että hakija hyväksyy kutsun",
    "deleteCandidate": "Poista ehdokas",
    "deleteCandidateBody": "Tätä toimintoa ei voi peruuttaa. Siirrythän tietylle poolisivulle ja poista ehdokas sieltä",
    "goToPool": "Siirry pooliin",
    "goToPoolNamed": "Siirry {title}",
    "moveSelected": "Siirrä valitut ehdokkaat toiseen pooliin",
    "moveNamedPrefix": "Siirrä",
    "moveNamedSuffix": "toiseen pooliin",
    "removeFromOrigin": "Poista alkuperäisestä poolista",
    "actionsForTalent": "Osaajaa koskevat toimenpiteet",
    "pools": "Poolit:",
    "teams": "Tiimit:",
    "addCandidateToTeam": "Lisää hakija tiimiin",
    "selectTeam": "Valitse tiimi",
    "inviteCandidateForPosition": "Kutsu hakija tehtävään",
    "jobPositions": "Työpaikat",
    "selectJobPosition": "Valitse työtehtävä",
    "matchPercent": "Yhteensopivuus {percentage} %",
    "percentMatch": "Yhteensopivuus {percentage} %",
    "downloadableReportAlt": "Ladattava raportti",
    "sendReminder": "Lähetä arviointimuistutus",
    "status": "Tila",
    "filters": {
      "addFilter": "Lisää suodatin",
      "apply": "Käytä",
      "valueBetween": "Arvo: {min}–{max}",
      "savedFilters": "Tallennetut suodattimet",
      "saveFilter": "Tallenna suodatin",
      "saveFilterPrompt": "Ole hyvä ja anna tämän suodattimen nimi",
      "filterName": "Suodattimen nimi",
      "filterNameExample": "esim. Yrityksen yhteiset arvot",
      "type": "Tyyppi",
      "selectType": "Valitse tyyppi",
      "selectTeamsList": "Valitse tiimit",
      "selectJobPositionList": "Valitse tehtävät",
      "search": "Hae",
      "teamsAssignedNone": "ei tiimiä määritetty",
      "teamsAssignedOne": "{count} tiimi määritetty",
      "teamsAssignedMany": "{count} tiimiä määritetty",
      "poolsAssignedNone": "ei poolia määritetty",
      "poolsAssignedOne": "{count} pooli määritetty",
      "poolsAssignedMany": "{count} poolia määritetty"
    },
    "perfectMatches": "{matches} täydellistä osumaa {total} hakijasta",
    "grid": {
      "sortAsc": "Lajittele nousevasti",
      "sortDesc": "Lajittele laskevasti",
      "filter": "Suodatin",
      "hideColumn": "Piilota sarake",
      "manageColumns": "Hallitse sarakkeita",
      "prev": "Edellinen",
      "next": "Seuraava"
    },
    "toasts": {
      "moveFailed": "Hakijan siirtäminen tiimiin {name} epäonnistui. Yritä uudelleen.",
      "reminderSent": "Muistutusviesti lähetetty",
      "reminderError": "Ei voitu lähettää muistutusviestiä",
      "generatingReport": "Luodaan raporttia...",
      "reportGenerated": "Raportti luotu",
      "reportFailedRetry": "Raportin luominen epäonnistui. Yritä uudelleen tai ota yhteyttä tukitiimiimme.",
      "reportFailed": "Raportin luominen epäonnistui"
    }
  }
};

export default dictionary;
